import { useConfigStore } from '@/store/configStore';

const ChatWatermark = () => {
  const { config } = useConfigStore();

  const configWatermark = config.ui?.watermark;

  return (
    <div className="flex items-center justify-center">
      {configWatermark === 'default' && (
        <a
          href="https://www.1648.group/"
          target="_blank"
          className="flex items-center justify-center gap-[6px] text-[#9e72b4] transition-colors hover:text-[#5D1482]"
        >
          <svg
            className="h-[24px]"
            viewBox="0 0 222 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M221.176 17.355V46.0095H214.25V17.355H221.176Z" fill="#171717" />
            <path
              d="M190.443 46.0095H183L192.668 17.355H201.888L211.557 46.0095H204.113L197.383 24.5746H197.159L190.443 46.0095ZM189.45 34.7324H205.009V39.9932H189.45V34.7324Z"
              fill="#171717"
            />
            <path
              d="M166.626 30.5757C168.608 29.2512 169.863 27.2076 169.863 24.6411C169.863 19.8796 166.136 17 160.495 17C154.932 17 151.127 19.8796 151.127 24.6411C151.127 27.211 152.382 29.2512 154.364 30.5757C151.923 32.0585 150.345 34.5253 150.345 37.7386C150.345 43.1262 154.888 46.4978 160.495 46.4978C166.102 46.4978 170.645 43.1296 170.645 37.7386C170.645 34.5253 169.067 32.0585 166.626 30.5757ZM160.495 22.0849C162.317 22.0849 163.793 23.6296 163.793 25.5321C163.793 27.4347 162.317 28.9794 160.495 28.9794C158.672 28.9794 157.196 27.4347 157.196 25.5321C157.196 23.6296 158.676 22.0849 160.495 22.0849ZM160.495 41.3854C158.356 41.3854 156.618 39.5723 156.618 37.3361C156.618 35.0998 158.353 33.2867 160.495 33.2867C162.634 33.2867 164.371 35.0998 164.371 37.3361C164.371 39.5723 162.637 41.3854 160.495 41.3854Z"
              fill="#171717"
            />
            <path
              d="M85.7148 23.9856H90.2747V46.2655H97.0652V17.5556H85.7148V23.9856Z"
              fill="#171717"
            />
            <path
              d="M125.181 34.7913V40.2993H138.306V46.2787H145.056V17.555H136.739L125.181 34.7913ZM138.677 34.7913H131.879L138.677 24.6525V34.7913Z"
              fill="#171717"
            />
            <path
              d="M112.264 27.9277L119.268 17.555H111.975C111.975 17.555 109.673 21.0126 106.466 25.774C104.31 28.977 101.991 32.1147 101.991 36.5493C101.991 42.2466 105.936 46.6743 112.043 46.6743C117.854 46.6743 122.332 43.0447 122.332 37.0172C122.329 31.3096 118.442 27.4805 112.264 27.9277ZM112.243 40.9943C110.07 40.9943 108.306 39.1812 108.306 36.9415C108.306 34.7018 110.067 32.8887 112.243 32.8887C114.416 32.8887 116.181 34.7018 116.181 36.9415C116.181 39.1812 114.416 40.9943 112.243 40.9943Z"
              fill="#171717"
            />
            <path
              d="M47.414 8.89929V25.3438L32 16.4445L16.586 25.3438V8.89929L32 0L47.414 8.89929Z"
              fill="#171717"
            />
            <path
              d="M32 19.1526L17.7631 27.3723L32 35.592L46.2369 27.3723L32 19.1526Z"
              fill="#171717"
            />
            <path
              d="M16.586 45.8505L30.8266 54.0723V37.6278L16.586 29.406V45.8505Z"
              fill="#171717"
            />
            <path
              d="M33.1734 54.0724V37.6279L47.414 29.406V45.8505L33.1734 54.0724Z"
              fill="#171717"
            />
            <path
              d="M48.586 64.3214L34.3491 56.1017L49.7593 47.2046V29.4017L64 37.6235V55.4221L48.586 64.3214Z"
              fill="#171717"
            />
            <path
              d="M14.2407 29.4017L0 37.6235V55.4221L15.414 64.3214L29.6509 56.1017L14.2407 47.2046V29.4017Z"
              fill="#171717"
            />
          </svg>
        </a>
      )}

      {configWatermark === 'compact' && (
        <a
          href="https://www.1648.group/"
          target="_blank"
          className="flex items-center gap-1 text-xs font-medium text-gray-500"
        >
          Supported by 1648 Factory
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.666992 7.33366L7.33366 0.666992M7.33366 0.666992H0.666992M7.33366 0.666992V7.33366"
              stroke="#717680"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      )}
    </div>
  );
};

export default ChatWatermark;
